import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';

import { ConfirmModalComponent } from './confirm-modal.component';

@NgModule({
    imports: [CommonModule, ModalBaseModule],
    declarations: [ConfirmModalComponent],
    exports: [ConfirmModalComponent],
})
export class ConfirmModalModule {}
